import { useState, useEffect } from "react";
import { ethers } from "ethers";
import genericErc20Abi from "../../tokens/Erc20.json";

export default function TokenBalance(props) {
  const [tokenBalance, setTokenBalance] = useState(0);

  async function getTokenBalance(_address) {
    const network = props.NODES.BSC.node;
    // console.log(1, network);
    const provider = ethers.getDefaultProvider(network);
    const tokenContractAddress = "0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56"; // BUSD = получаем BUSD в сети BSC для всех кошельков пользователя
    const contract = new ethers.Contract(
      tokenContractAddress,
      genericErc20Abi,
      provider
    );
    // const balance = (await contract.balanceOf((await provider.getSigners())[0].address)).toString();
    // const balance = (await contract.balanceOf(address)).toString();
    const balance = await contract.balanceOf(_address);
    const balanceInEth = ethers.utils.formatEther(balance);
    console.log("getTokenBalance()=", network, _address, balance, balanceInEth);
    return balanceInEth;
  }

  useEffect(() => {
    try {
      {
        console.log(props.wallet);
        if (props.wallet)
          getTokenBalance(props.wallet).then((bal) => {
            console.log(props.wallet, bal, "BUSD @ BSC");
            setTokenBalance("BUSD @ BSC " + +(+bal).toFixed(4));
          });
      }
    } catch (e) {
      console.log(e);
    }
  }, [props.wallet]);

  return <div>{tokenBalance}</div>;
}
